import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CuiButtonComponent, CuiDialogContainerComponent } from '@idealink-material/ui-core';
import { AuthService } from '@/core/service/auth.service';
import { SessionMonitorService } from '@/core/service/session-monitor.service';
import { SessionStatus } from '@/core/model/session-status';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-session-duration-expired',
    template: `
        <p-dialog-container #dialogContainer [title]="'session.expired.title' | translate" [showClose]="false" [dividers]="false">
            <div class="flex text-center mt-3 mb-3">
                <p>{{ 'session.expired.message' | translate }}</p>
            </div>
            <div class="text-center mt-8 mb-3">
                <p-button icon="logout" iconPos="left" (onClick)="closed()">{{ 'session.expired.logout' | translate }}</p-button>
            </div>
        </p-dialog-container>
    `,
    styleUrl: './custom-dialog.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CuiButtonComponent, CuiDialogContainerComponent, ReactiveFormsModule, TranslatePipe]
})
export class SessionDurationExpired {
    @ViewChild('dialogContainer') dialogContainer!: CuiDialogContainerComponent;
    authService = inject(AuthService);
    private sessionMonitor = inject(SessionMonitorService);

    closed() {
        this.dialogContainer.close();
        this.sessionMonitor.setStatus(SessionStatus.Active);
        this.authService.logout();
    }
}
